// 9fbef606107a605d69c0edbcd8029e5d
import { GIFT_SERVICES_ACTION_PATTERN } from '../../../../../../../../constants/reducer.constants';

const GIFT_SERVICES_CONSTANTS = {
  ADD_GIFT_SERVICES_REQUEST: `${GIFT_SERVICES_ACTION_PATTERN}ADD_GIFT_SERVICES_REQUEST`,
  REMOVE_GIFT_SERVICES_REQUEST: `${GIFT_SERVICES_ACTION_PATTERN}REMOVE_GIFT_SERVICES_REQUEST`,
  GYM: 'GYM',
  TCP: 'TCP',
  SNJ: 'SNJ',
  PJP: 'PJP',
  GIFT_SERVICES_OPTION_NONE: 'none',
  GIFT_SERVICES_NONE_VALUE: 'NO_GIFT',
};

export default GIFT_SERVICES_CONSTANTS;
